import { render, staticRenderFns } from "./DomainBasedIntranetAccess.vue?vue&type=template&id=a824622e&scoped=true&"
import script from "./DomainBasedIntranetAccess.vue?vue&type=script&lang=js&"
export * from "./DomainBasedIntranetAccess.vue?vue&type=script&lang=js&"
import style0 from "./DomainBasedIntranetAccess.vue?vue&type=style&index=0&id=a824622e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a824622e",
  null
  
)

export default component.exports